export const searchItems = (items, query) => {
    return items.filter((item) => {
        const text = Object.values(item)
            .map((v) => (typeof v === 'string' ? v : ''))
            .join(' ')
            .toLocaleLowerCase();
        return text.includes(query.toLocaleLowerCase());
    });
};
